export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export const addToList = property => (state, payload) => (state[property].unshift(payload))

export const clearList = property => (state) => (state[property] = [])
